import { getLoadedConfig, loadConfig } from "../services/configLoader";

export async function loadRuntimeConfig() {
  return loadConfig();
}

export function getRuntimeConfig() {
  const runtimeConfig = getLoadedConfig();

  if (!runtimeConfig) {
    throw new Error("Runtime config has not been loaded yet");
  }

  return runtimeConfig;
}
